module.exports = __webpack_public_path__ + "img/xmly.2cf2e76d.png";